/*
 * @Author: edvardchen
 * @Date: 2018-01-25 20:40:13
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2019-11-29 16:04:06
 */

// @flow
import { isIOS } from '@tencent/qb-article-util/lib/UA';
import isRN from '@tencent/qb-article-util/lib/isRN';

let isRNPostMessageReady = false;
let listeners = [];
let inited = false;

export default () => {
  if (inited) {
    return;
  }
  inited = true;
  const inIOS = isIOS(window.navigator.userAgent);
  if (inIOS) {
    isRNPostMessageReady = isRN();
  } else {
    isRNPostMessageReady = !!(window.__REACT_WEB_VIEW_BRIDGE && window.__REACT_WEB_VIEW_BRIDGE.postMessage && isRN());
  }
  console.log('===isReactNativePostMessageReady===', isRNPostMessageReady);

  const { store: postMessageWithQueue, sendQueue } = (() => {
    const queue = [];
    return {
      sendQueue: () => {
        console.debug(`${queue.length} messages stored, postMessage now`);
        while (queue.length > 0) window.postMessage(queue.shift());
      },
      store: (message) => {
        // store
        queue.push(message);
      },
    };
  })();
  const postMessageFn = inIOS ? window.postMessage : window.__REACT_WEB_VIEW_BRIDGE.postMessage;
  let currentPostMessageFn = isRNPostMessageReady ? postMessageFn : postMessageWithQueue;

  const chianForIOS = (() => {
    const INTERVAL = 100;
    let promiseChain = Promise.resolve();

    return (message) => {
      console.debug('====hijack postMesage', message, Date.now());
      promiseChain = promiseChain.then(
        () =>
          new Promise((resolve) => {
            console.debug('===postMessage', message, Date.now());
            try {
              currentPostMessageFn(message);
            } catch (e) {
              /* ignore */
            }
            setTimeout(resolve, INTERVAL);
          }),
      );
    };
  })();

  // 1. RN postMessage not ready
  // 2. ready but in iOS
  if (!isRNPostMessageReady || inIOS) {
    const descrp = Object.getOwnPropertyDescriptor(window, 'postMessage');
    if (descrp && !descrp.configurable) {
      console.error('postMessage un-configurable');
      return;
    }
    try {
      Object.defineProperty(
        window,
        'postMessage',
        ({
          configurable: true,
          enumerable: true,
          get() {
            return inIOS ? chianForIOS : currentPostMessageFn;
          },
          set(fn) {
            currentPostMessageFn = fn;
            isRNPostMessageReady = true;

            // 广播
            listeners.forEach((item) => item());
            listeners = [];

            setTimeout(sendQueue, 0);
          },
        }: Object),
      );
    } catch (e) {
      console.error('exception: defineProperty window.postMessage failed', e);
    }
  }
};

export const listenToPostMessageReady = (callback: Function) => {
  if (isRNPostMessageReady) {
    // setTimeout(callback);
    callback && callback();
    return;
  }
  listeners.push(callback);
};
